import React from 'react'

const GooglePlay = require('../../../assets/img/googlePlay.png')
const AppStore = require('../../../assets/img/appStore.png')

const GooglePlayBadge = ({ link, ...props }) => (
  <a href={link} target="_blank" rel="noopener noreferrer" {...props}>
    <img
      loading="lazy"
      src={GooglePlay}
      width={GooglePlay.width}
      height={GooglePlay.height}
      className="store-badge my-2"
      alt="Selo do Google Play"
    />
  </a>
)

const AppStoreBadge = ({ link, ...props }) => (
  <a href={link} target="_blank" rel="noopener noreferrer" {...props}>
    <img
      loading="lazy"
      src={AppStore}
      width={AppStore.width}
      height={AppStore.height}
      className="store-badge my-2"
      alt="Selo da App Store"
    />
  </a>
)

export { GooglePlayBadge, AppStoreBadge }
